export const WIDGET_PLACEHOLDER_CLASSES = [
  'hawk-placeholder',
  'hawk-nest',
  'hawk-base',
  'hawk-root',
  'ecom-root',
];
export const WIDGET_PLACEHOLDER_SELECTOR = WIDGET_PLACEHOLDER_CLASSES.map((c) => `.${c}`).join(',');
export const CURRENT_WIDGET_PLACEHOLDER_CLASS = WIDGET_PLACEHOLDER_CLASSES.at(-1) as string;
export const WIDGETS_SCRIPT = 'ecomwidgets';
export const LINKS_SCRIPT = 'ecomlinks';
